import { useEffect, useState } from 'react';
import axios from 'axios';
import type { TeamMember } from '../types';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Gedeelde teamledenlijst voor deelnemer-, voorzitter-, notulist- en
 * toewijzingskeuzes doorheen de Leiderschap-module. */
export default function useTeamMembers() {
  const [teamMembers, setTeamMembers] = useState<TeamMember[]>([]);

  useEffect(() => {
    let active = true;
    axios
      .get<TeamMember[]>(`${API}/team`)
      .then((response) => {
        if (active) setTeamMembers(response.data);
      })
      .catch(() => {
        if (active) setTeamMembers([]);
      });
    return () => {
      active = false;
    };
  }, []);

  return teamMembers;
}
